import { action, observable } from 'mobx';
import {signUp, vcode} from '@/services/accountRelated';
import { checkMobile, checkPassword, checkVcode } from '@/utils/checkInput';
import { mobileErrText, passwordErrText, vcodeErrText } from '@/utils/constants';
import router from '@/router';
import GlobalStore from '@/store/GlobalStore';
import log from '@/utils/log';


class SignUpStore {

  // 注册信息
  @observable signUpInfo = {
    mobile: '',
    password: '',
    password2: '',
    code: '',
  }

  @observable inputError = {
    text: '',
    type: ''
  };

  // 获取验证码状态
  @observable codeButton = {
    disable: false,
    text: '发送验证码'
  }

  @observable captchaVisible = false

  @action.bound closeCaptcha () {
    this.captchaVisible = false
  }

  @action.bound getSMSCaptcha () {
    if (this.codeButton.disable) return ;
    this.captchaVisible = true
  }

  @action.bound successCaptcha (verification) {
    this.captchaVisible = false

    this.vcode(verification)
  }
  // 注册接口数据
  @observable signUpData

  // 获取验证码接口数据
  @observable vcodeData

  @observable toast = GlobalStore.toast

  // 注册
  @action.bound async signUp () {
    const { mobile, password, password2 , code} = this.signUpInfo;

    if (!checkMobile(mobile)) {
      this.toast.text(mobileErrText)
      this.inputError = {text: mobileErrText, type: 'mobile'}
      return false
    }

    if (!checkVcode(code)) {
      this.toast.text(vcodeErrText)
      this.inputError = {text: vcodeErrText, type: 'code'}

      return false
    }

    if (!checkPassword(password)) {
      this.inputError = {text: passwordErrText, type: 'password'}
      this.toast.text(passwordErrText)
      return false
    }

    if (password !== password2) {
      this.inputError = {text: '两次密码输入不一致', type: 'password2'}
      this.toast.text('两次密码输入不一致')
      return false
    }
    this.inputError = {text: '', type: ''}
    const loading = this.toast.loading();
    this.signUpData = await signUp({mobile,password,code, channel: GlobalStore.channel})
    loading.hide()
    if (this.signUpData.code !== 10000) {
      await log.logRequest({eventId: 'A004',failReason: this.signUpData.msg })
      this.toast.text(this.signUpData.code === 50003 ? this.signUpData.msg : this.signUpData.result)
      return false
    }
    await log.logRequest({eventId: 'A003',failReason: this.signUpData.msg })
    this.toast.text(this.signUpData.msg)
    router.push({ path: '/' })
  }

  // 获取验证码
  @action.bound async vcode (verification: string) {
    await log.logRequest({eventId: 'A023'})
    if (!checkMobile(this.signUpInfo.mobile)) {
      this.toast.text(mobileErrText)
      return false
    }
    this.codeButton = Object.assign({}, this.codeButton, {disable : true})
    this.vcodeData = await vcode({mobile: this.signUpInfo.mobile, type: 3, verification:verification, source: 5 })
    if (this.vcodeData.code !== 10000) {
      this.codeButton = Object.assign({}, this.codeButton, {disable : false})
      this.toast.text(this.vcodeData.code === 50003 ? this.vcodeData.msg : this.vcodeData.result)
      return false
    }
    this.countDown()
  }

  @action.bound inputOnChange (value: string, name: string)  {
    this.signUpInfo = Object.assign({}, this.signUpInfo, {[name] : value})
  }

  // 倒计时
  @action.bound countDown () {
    let time = 60;
    time = time -1
    const countDownInterval = setInterval(() => {
      if (time === 1) {
        this.codeButton = {
          disable: false,
          text: '发送验证码'
        }
        clearInterval(countDownInterval)
        return
      }
      this.codeButton = {
        text: `重新发送(${time = time -1})`,
        disable: true
      }
    }, 1000)
  }

  @action.bound routerPushSignIn () {
    router.push({ path: '/' })
  }

}

export default new SignUpStore();
